import React, { useEffect } from "react";
import styles from "./SubmittedForms.module.scss"

import { GrFormView } from 'react-icons/gr';
import { AiOutlineDownload } from 'react-icons/ai';

const SubmittedForms = () => {
    useEffect(() => {
        document.title = "Briding 365 | Forms";
        window.scrollTo(0, 0);
    }, []);
    const submittedForms = [
        {
            id: 1,
            submittedOn: "20th Jun2 2022",
            purpose: "Purchase"
        },
        {
            id: 2,
            submittedOn: "20th Jun2 2022",
            purpose: "Refinance"
        },
        {
            id: 3,
            submittedOn: "20th Jun2 2022",
            purpose: "Capital raise - home improvements"
        },
        {
            id: 4,
            submittedOn: "20th Jun2 2022",
            purpose: "Stop reposessions"
        },
    ]
    return (
        <div className={styles.submittedForms}>
            <p className={styles.header}>Forms submitted till date</p>
            {submittedForms.map((item) => {
                return <div className={styles.formItem}>
                    <div className={styles.left}>
                        <p>Form {submittedForms.indexOf(item) + 1}</p>
                        <p>Purpose : {item.purpose} </p>
                        <p>Submitted on :{item.submittedOn} </p>
                    </div>
                    <div className={styles.right}>
                        <span><GrFormView title="View" className={styles.icon} /></span>
                        <span><AiOutlineDownload title="Download" className={styles.icon} /> </span>
                    </div>

                </div>
            })}
        </div>
    );
};

export default SubmittedForms;
